import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-logo-project',
    templateUrl: './logo-project.component.html',
    styleUrls: ['./logo-project.component.scss']
})
export class LogoProjectComponent implements OnInit {
    @Input() size = '3.2rem';

    constructor() {
    }

    ngOnInit(): void {
    }

}
